var axios;
var Swiper;
var WebSite;
(function (WebSite) {
    var AFWSwiper = (function () {
        function AFWSwiper(element, swiperSettings) {
            if (swiperSettings === void 0) { swiperSettings = null; }
            this.SwiperSettings = null;
            var swpSetJson = swiperSettings || element.getAttribute('data-swiper-settings');
            if (swpSetJson) {
                this.SwiperSettings = JSON.parse(swpSetJson);
            }
            new Swiper(element, this.SwiperSettings);
        }
        return AFWSwiper;
    }());
    WebSite.AFWSwiper = AFWSwiper;
    var Main = (function () {
        function Main() {
            this.hangWebsiteSubmitForms = function () {
                var elements = document.querySelectorAll('[data-wssubmitform]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    hangAsyncSubmitToForm(el);
                }
            };
            this.bindSwiperTmpFunc = function () {
                var elements = document.querySelectorAll('[data-swiper-init]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    new WebSite.AFWSwiper(el);
                }
            };
            this.referencesSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-references-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    slideToClickedSlide: true,
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 2,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-references-button-next',
                        prevEl: '.swiper-references-button-prev'
                    },
                });
                swiper.on("slideChange", function () {
                    $(".comments-block").removeClass("active");
                    $(".comments").find('[data-index="' + swiper.realIndex + '"]').addClass("active");
                });
            };
            this.countdownInit = function () {
                if ($(".countdown").length > 0) {
                    var target_date = new Date('March, 1, 2022').getTime();
                    var days, hours, minutes, seconds;
                    setInterval(function () {
                        var daysDiv = $(".countdown-days");
                        var hoursDiv = $(".countdown-hours");
                        var minutesDiv = $(".countdown-minutes");
                        var secondsDiv = $(".countdown-seconds");
                        var current_date = new Date().getTime();
                        var seconds_left = (target_date - current_date) / 1000;
                        days = seconds_left / 86400;
                        seconds_left = seconds_left % 86400;
                        hours = seconds_left / 3600;
                        seconds_left = seconds_left % 3600;
                        minutes = seconds_left / 60;
                        seconds = seconds_left % 60;
                        daysDiv.html(Math.floor(days).toString());
                        hoursDiv.html(Math.floor(hours).toString());
                        minutesDiv.html(Math.floor(minutes).toString());
                        secondsDiv.html(Math.floor(seconds).toString());
                    }, 1000);
                }
            };
            this.stickyNavigation = function () {
                var header = $("header");
                if ($(window).scrollTop() >= 1) {
                    header.addClass("sticky");
                }
                else {
                    header.removeClass("sticky");
                }
                $(window).scroll(function () {
                    if ($(window).scrollTop() >= 1) {
                        header.addClass("sticky");
                    }
                    else {
                        header.removeClass("sticky");
                    }
                });
            };
            this.mobileMenu = function () {
                var hamburger = $("#hamburger-menu");
                var mobileMenu = $("#mobile-menu");
                var header = $("header");
                var body = $("body");
                var buttonsMobileMenu = $(".mobile-menu-footer .btn");
                hamburger.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                    if (!header.hasClass("sticky")) {
                        header.addClass("sticky");
                    }
                });
                buttonsMobileMenu.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                });
            };
            this.hangWebsiteSubmitForms();
            this.bindSwiperTmpFunc();
            this.referencesSwiper();
            this.countdownInit();
            this.stickyNavigation();
            this.mobileMenu();
        }
        return Main;
    }());
    WebSite.Main = Main;
    function hangAsyncSubmitToForm(form) {
        form.addEventListener('submit', function (e) {
            var formEl = $(this);
            if (!formEl.valid())
                return;
            e.preventDefault();
            $.ajax({
                type: "POST",
                dataType: "JSON",
                method: "POST",
                data: AllForWeb.getFormData(formEl)
            }).then(function (result) {
                var formResponse = formEl.find(".form-respons");
                formResponse.show();
                var formStructure = formEl.find(".form-submit");
                formStructure.hide();
                setTimeout(function () {
                    formEl.find('input').not('[type=hidden], [type=checkbox]').val('');
                    var formResponse = formEl.find(".form-respons");
                    formResponse.hide();
                    var formStructure = formEl.find(".form-submit");
                    formStructure.show();
                }, 3000);
            }, function (err) {
            });
        });
    }
    WebSite.hangAsyncSubmitToForm = hangAsyncSubmitToForm;
})(WebSite || (WebSite = {}));
(function () {
    new WebSite.Main();
    var domainName = window.location.hostname;
    var cookieMain = $('.cookie');
    var cookieWarning = $(".cookie-dialog", cookieMain);
    $("#accept-cookies", cookieMain).on('click', function () {
        Cookies.set("analytic_consent", "1", { expires: 365, path: '/', domain: domainName });
        Cookies.set("analytic_consentNoPopUp", "1", { expires: 30, path: "/", domain: domainName });
        $('.cookie-dialog', cookieMain).fadeOut();
        window.location.reload();
    });
    var lastScrollTop = 0;
    $(window).on('scroll', function () {
        var el = $('.landing-shape');
        var currentBottomOffset = parseInt(el.css('bottom'));
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            el.css('bottom', currentBottomOffset + 5 + "px");
        }
        else {
            el.css('bottom', currentBottomOffset - 5 + "px");
        }
        lastScrollTop = st;
    });
    $('.mobile-dropdown-toggle').on('click', function () {
        $('.mobile-dropdown').toggleClass('show');
    });
})();
var initLandingSwiper = (function () {
    var el = document.querySelector("#landing-swiper");
    var swiper = new Swiper(el, {
        effect: 'fade',
        speed: 1000,
        autoplay: {
            delay: 3000,
        },
        slidesPerView: 1,
        navigation: {
            nextEl: '.landing-swiper-next',
            prevEl: '.landing-swiper-prev',
        },
        pagination: {
            el: '.landing-swiper-pagination',
            renderBullet: function (index, className) {
                return '<span class="' + className + '" data-id="' + index + '"></span>';
            },
            clickable: true,
        }
    });
})();
var eventSlideshowSwiper = (function () {
    var el = document.querySelector("#event-slideshow");
    var swiper = new Swiper(el, {
        speed: 1000,
        autoplay: {
            delay: 8000,
        },
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.landing-swiper-next',
            prevEl: '.landing-swiper-prev',
        },
        pagination: {
            el: '.landing-swiper-pagination',
            renderBullet: function (index, className) {
                return '<span class="' + className + '" data-id="' + index + '"></span>';
            },
            clickable: true,
        }
    });
})();
$('.custom-page-button').on('click', function () {
    var id = $(this).data("target");
    var element = $(".landing-swiper-pagination").find("[data-id=" + id + "]");
    console.log(id, element);
    if (element) {
        element.click();
    }
});
var currentView = "active";
var tag = null;
$('.event-tab').on('click', function () {
    var id = $(this).attr("id");
    $('.event-tab').removeClass("active");
    currentView = id == "active-events" ? "active" : "archive";
    if (currentView == "active") {
        $(".active-list").show();
        $(".archive-list").hide();
    }
    else {
        $(".active-list").hide();
        $(".archive-list").show();
    }
    $(this).addClass("active");
});
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return null;
};
var applyFilter = function (tag) {
    $('.event').each(function () {
        var eventTag = $(this).data("tag");
        var tagFilter = true;
        if (tag)
            tagFilter = tag.toLowerCase() == eventTag.toLowerCase();
        if (tagFilter)
            $(this).show();
        else
            $(this).hide();
    });
    if ($('.event:visible').length < 1) {
        $("#no-events-text").show();
    }
};
if ($(".EventList")[0]) {
    tag = getUrlParameter("tag");
    if (tag) {
        $('.event-filter').show();
        $('.event-filter').text(tag);
    }
    applyFilter(tag);
    $('.event-filter').on('click', function () {
        $("#no-events-text").hide();
        $('.event-filter').hide();
        tag = null;
        applyFilter(tag);
    });
}
$('.expand').on('click', function () {
    $(this).toggleClass("active");
    $('.mobile-menu').toggleClass("visible");
});
$('#event-register').on('click', function () {
});
$('.event-type-box').on('click', function () {
    $('.event-type-box').removeClass("selected");
    $(this).toggleClass("selected");
    $(".event-type-box").find('input').removeAttr("checked");
    $(this).find('input').attr("checked", "checked");
});
$('#supervisor-info').find('input').on('keyup', function () {
    checkSupervisorInfo();
});
$("#Age").on('keyup', function () {
    var val = $(this).val();
    if (val >= 18) {
        $('#supervisor-info').hide();
    }
    else {
        $('#supervisor-info').show();
    }
    validateForm();
});
$('#Consent').on('change', function () {
    $(this).siblings(".tickbox-text").toggleClass("checked");
    validateForm();
});
$('#OverEighteen').on('change', function () {
    $(this).siblings(".tickbox-text").toggleClass("checked");
    validateForm();
});
$('#Newsletter').on('change', function () {
    $(this).siblings(".tickbox-text").toggleClass("checked");
    validateForm();
});
var checkSupervisorInfo = function () {
    var supervisorFields = [
        $("#SupervisorName"),
        $("#SupervisorLastName"),
        $("#SupervisorPhoneNumber"),
        $("#SupervisorEmail")
    ];
    var isValid = true;
    supervisorFields.forEach(function (field) {
        if (field.val() == null || field.val().trim() == '')
            isValid = false;
    });
    return isValid;
};
var mandatoryInfo = function () {
    var isValid = true;
    var mandatoryFields = [
        $("#Name"),
        $("#Surname"),
        $("#EmailAddress"),
        $("#Age"),
    ];
    console.log("###################");
    mandatoryFields.forEach(function (field) {
        console.log(field.attr("name"), field.val());
        if (field.val() == null || field.val().trim() == '')
            isValid = false;
    });
    if (!$("#Consent").is(":checked"))
        isValid = false;
    console.log("Consent: " + $("#Consent").is(":checked"));
    console.log("###################");
    return isValid;
};
var validateForm = function () {
    if ($("#Age").val() < 18) {
        if (mandatoryInfo() && checkSupervisorInfo())
            enableSubmitBtn();
        else
            disableSubmitBtn();
    }
    else {
        if (mandatoryInfo() && $("#OverEighteen").is(":checked"))
            enableSubmitBtn();
        else
            disableSubmitBtn();
    }
};
var enableSubmitBtn = function () {
    $('#submit-registration').removeAttr("disabled");
};
var disableSubmitBtn = function () {
    $('#submit-registration').attr("disabled", "disabled");
};
var specialTxt = $('.special-text').text();
if (specialTxt.length) {
    var partnerArr = specialTxt.split("\n")[1].split(" / ");
    partnerArr.forEach(function (partner) { return partner = partner.trim(); });
    var content = partnerArr.join("<span class=\"partner-divider\">&nbsp;/&nbsp;</span>");
    $('.special-text').html("<p>" + content + "</p>");
}
//# sourceMappingURL=Main.js.map